<template>
  <div id="app">
    <TheHeader @onClickMenu="navMenuVisible = !navMenuVisible" />
    <section class="top">
      <img src="@/assets/bg-product.jpg" alt="" />
      <div>
        <h1>商品一覧</h1>
      </div>
    </section>
    <ProductList />
    <TheFooter />
    <NavMenu v-show="navMenuVisible" />
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader'
import TheFooter from '@/components/TheFooter'
import NavMenu from '@/components/NavMenu'
import ProductList from '@/components/ProductList'

export default {
  name: 'App',

  data() {
    return {
      navMenuVisible: false
    }
  },

  components: {
    TheHeader,
    TheFooter,
    NavMenu,
    ProductList
  }
}
</script>

<style lang="scss">
#app {
  display: block;
  width: 100%;
  max-width: 414px;
  min-height: 100vh;
  margin: 0 auto;
  background: #fcfcfc;
  position: relative;
  overflow: hidden;

  > .top {
    position: relative;
    width: 100%;
    height: 216px;

    > div {
      position: absolute;
      top: 0;
      width: 100%;
      height: inherit;
      display: flex;
      justify-content: center;
      align-items: center;

      > h1 {
        color: #1c1c3e;
        font-size: 1.25em;
      }
    }

    > img {
      height: inherit;
      width: 100%;
      object-fit: fill;
    }
  }
}
</style>
